enum QHPStarRatingTypeEnum {
  Five = "5",
  Four = "4",
  Three = "3",
  Two = "2",
  One = "1",
  NA = "N/A",
}

export { QHPStarRatingTypeEnum };
